import { atomWithStorage } from 'jotai/utils';

export const isConvertedUserAtom = atomWithStorage<boolean>(
  'is_converted_user',
  null
);
